import { render, staticRenderFns } from "./RegisterPerson.vue?vue&type=template&id=716e19a0&scoped=true"
import script from "./RegisterPerson.vue?vue&type=script&lang=js"
export * from "./RegisterPerson.vue?vue&type=script&lang=js"
import style0 from "./RegisterPerson.vue?vue&type=style&index=0&id=716e19a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "716e19a0",
  null
  
)

export default component.exports